import { useEffect, useState } from 'react';
import { getHeaderAutoCollapseEnabled } from '../utils/headerAutoCollapse';

/**
 * Subscribes to the header auto-collapse preference stored in localStorage.
 * Reacts to both cross-tab `storage` events and same-tab custom events
 * dispatched by `setHeaderAutoCollapseEnabled`.
 */
export function useAutoCollapseEnabled(): boolean {
  const [enabled, setEnabled] = useState(getHeaderAutoCollapseEnabled);

  useEffect(() => {
    const sync = () => setEnabled(getHeaderAutoCollapseEnabled());

    const handleStorage = (e: StorageEvent) => {
      if (e.key === 'header_auto_collapse_enabled') sync();
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('headerAutoCollapseChanged', sync);

    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('headerAutoCollapseChanged', sync);
    };
  }, []);

  return enabled;
}
